import Compressor from 'compressorjs';

export function getClientEnv() {
  const userAgent = window.navigator.userAgent;
  const isWechat = /MicroMessenger/.test(userAgent);
  const isAlipay = /AlipayClient/.test(userAgent);

  return isWechat ? 'wechat' : isAlipay ? 'alipay' : 'browser';
}

export function getPlatform() {
  const userAgent = window.navigator.userAgent;
  const isIos = /iPhone/.test(userAgent) || /iPad/.test(userAgent);

  return isIos ? 'ios' : 'android';
}

export function resizeOSSImage(filename) {
  const host = 'https://i3.cathay-ins.com.cn/prod/posts';
  const width = parseInt(window.devicePixelRatio * 360) || 360;
  return `${host}/${filename}.png?x-oss-process=image/resize,w_${width}`;
}

export function compressImage(file, options) {
  return new Promise((resolve, reject) => {
    return new Compressor(file, {
      ...options,
      success: resolve,
      error: reject,
    });
  }).catch(error => file);
}

export function buildFormData(value) {
  const formData = new FormData();
  Object.keys(value).forEach(key => {
    if (key === 'file') {
      formData.append(key, value[key], value[key].name);
    } else {
      formData.append(key, value[key]);
    }
  });
  return formData;
}
